/**
 * Fin St's Years / Quarters choice, saved per chart (owner, 2026-10-08).
 *
 * A context rather than a prop, because the panel that shows the switch sits
 * four components below the reducer that saves it (App → data panel → views →
 * the table), and only this one view wants it. `App` provides the reader and
 * the writer over `ChartGroup.finStGrain`; a panel with no chart behind it, or
 * no provider at all, keeps the choice in local state as it always did.
 */

import { createContext, useContext, useState } from "react";

export type FinStGrain = "years" | "quarters";

export interface FinStGrainStore {
  get: (chartGroupId: string) => FinStGrain;
  set: (chartGroupId: string, grain: FinStGrain) => void;
}

export const FinStGrainContext = createContext<FinStGrainStore | null>(null);

/** `[grain, setGrain]` for one chart's Fin St table. */
export function useFinStGrain(
  chartGroupId: string | undefined,
): [FinStGrain, (grain: FinStGrain) => void] {
  const store = useContext(FinStGrainContext);
  const [local, setLocal] = useState<FinStGrain>("years");
  if (store && chartGroupId) {
    return [store.get(chartGroupId), (grain) => store.set(chartGroupId, grain)];
  }
  return [local, setLocal];
}
